import api from 'service/api'

const dponetAPI = api.create('dponet')

const create = async ({ monitoringManagementNcId = '', ...params }) => {
  return await dponetAPI.post(
    `/monitoring_management_ncs/${monitoringManagementNcId}/monitoring_management_nc_actions`,
    { monitoringManagementNcAction: params },
  )
}

const update = async ({
  monitoringManagementNcId = '',
  monitoringManagementNcActionId = '',
  ...params
}) => {
  return await dponetAPI.put(
    `/monitoring_management_ncs/${monitoringManagementNcId}/monitoring_management_nc_actions/${monitoringManagementNcActionId}`,
    { monitoringManagementNcAction: params },
  )
}

const destroy = async ({
  monitoringManagementNcId = '',
  monitoringManagementNcActionId = '',
}) => {
  return await dponetAPI.delete(
    `/monitoring_management_ncs/${monitoringManagementNcId}/monitoring_management_nc_actions/${monitoringManagementNcActionId}`,
  )
}

export default {
  create,
  destroy,
  update,
}
